import { data } from '../../svg/AddLink/data';
import { makeIcon } from '../makeIcon';

export const AddLink = makeIcon(data, 'add_link', 'AddLink');

export default AddLink;
